import { render } from "./App.vue?vue&type=template&id=10adb0f1"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=10adb0f1&lang=css"

import exportComponent from "E:\\微课堂静态页面\\shop_pay_static_page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__